import { DataTableColumnHeader } from 'common/data-table-column-header';
import { checkIconWithValueCell, linkCell } from 'utils/cell-formatter';
import { formatISODate } from 'utils/formatDate';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/admin/provinces' }),
  },
  {
    accessorKey: 'fmarket_id',
    header: 'Fmarket ID',
    cell: checkIconWithValueCell,
  },

  {
    accessorKey: 'name',
    header: 'Name',
  },

  {
    accessorKey: 'address_version',
    header: 'Version',
  },

  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    meta: { className: 'text-right' },
    cell: ({ getValue }) => formatISODate(getValue()),
  },
  {
    accessorKey: 'updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updated" />
    ),
    meta: { className: 'text-right' },
    cell: ({ getValue }) => formatISODate(getValue()),
  },
];
